var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "data-view" } },
    [
      _c(
        "dv-full-screen-container",
        [
          _c("div", { staticClass: "top" }, [
            _c("div", { staticClass: "left" }, [
              _c("div", { staticClass: "time" }, [
                _vm._v(
                  "\n          出库监控: " +
                    _vm._s(_vm.board_data.date.start) +
                    " ~\n          " +
                    _vm._s(_vm.board_data.date.end) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "date" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c("div", { staticClass: "time" }, [
                _vm._v("\n          " + _vm._s(_vm.now_time) + "\n        ")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dv-border-box-2", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "dv-border-box-12",
                  {
                    staticClass: "left-top",
                    attrs: { "background-color": "#232931" }
                  },
                  [
                    _c("div", { staticClass: "left-content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "total",
                          staticStyle: { "line-height": "30px" }
                        },
                        [
                          _c("el-row", [
                            _vm._v(
                              "需发总件数: " +
                                _vm._s(_vm.board_data.wave_data.total_wave_num)
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-row", [
                            _vm._v(
                              "待发总件数: " +
                                _vm._s(_vm.board_data.wave_data.wave_num)
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-row", [
                            _vm._v(
                              "实配总件数: " +
                                _vm._s(_vm.board_data.wave_data.allot_num)
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "list",
                          staticStyle: {
                            "margin-top": "30%",
                            "line-height": "40px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 12 } }, [
                                _vm._v(
                                  "在库所需: " +
                                    _vm._s(_vm.board_data.wave_data.stock_in_pa)
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _vm._v(
                                  "单件分离: " +
                                    _vm._s(_vm.board_data.wave_data.only_biao)
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 12 } }, [
                                _vm._v(
                                  "上架待拣:\n                  " +
                                    _vm._s(
                                      _vm.board_data.wave_data.sjed_waitpa_num
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _vm._v(
                                  "质检分离: " +
                                    _vm._s(
                                      _vm.board_data.wave_data.quality_biao
                                    )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 12 } }, [
                                _vm._v(
                                  "越库分离: " +
                                    _vm._s(
                                      _vm.board_data.wave_data.surpass_biao
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 12 } }, [
                                _vm._v(
                                  "改标分离: " +
                                    _vm._s(_vm.board_data.wave_data.label_biao)
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "right-content" },
                      [_c("dv-charts", { attrs: { option: _vm.option } })],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { height: "2%" } }),
                _vm._v(" "),
                _c(
                  "dv-border-box-12",
                  {
                    staticClass: "left-bottom",
                    attrs: { "background-color": "#232931" }
                  },
                  [
                    _c("div", { staticClass: "left-content" }, [
                      _c(
                        "div",
                        { staticStyle: { height: "60%" } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { staticStyle: { color: "#ff8878" } },
                                [_vm._v("拣货进度")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    color: "#fff",
                                    "font-size": "12px"
                                  }
                                },
                                [_vm._v("任务数")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("dv-charts", { attrs: { option: _vm.ring } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "40%",
                            "line-height": "40px",
                            "text-align": "center",
                            "margin-top": "10%"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", [
                                _vm._v(
                                  "拣货任务\n                  " +
                                    _vm._s(
                                      _vm.board_data.pad_data.staticis
                                        .all_pad_num
                                    )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c("el-col", [
                                _vm._v(
                                  "已拣货\n                  " +
                                    _vm._s(
                                      _vm.board_data.pad_data.staticis
                                        .all_complete_pad_num
                                    )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c("el-col", [
                                _vm._v(
                                  "待拣货\n                  " +
                                    _vm._s(
                                      _vm.board_data.pad_data.staticis
                                        .all_wait_pad_num
                                    )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right-content" }, [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "right", height: "10%" }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", [
                                _vm._v(
                                  "拣货总波次数\n                  " +
                                    _vm._s(
                                      _vm.board_data.pad_data.total.pad_wave_num
                                    )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c("el-col", [
                                _vm._v(
                                  "\n                  拣货总件数\n                  " +
                                    _vm._s(
                                      _vm.board_data.pad_data.total.pad_sku_num
                                    )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.board_data.pad_data.category
                        ? _c(
                            "div",
                            { staticStyle: { height: "90%" } },
                            _vm._l(_vm.board_data.pad_data.category, function(
                              item
                            ) {
                              return _c(
                                "el-row",
                                {
                                  key: item.name,
                                  staticStyle: { "margin-top": "5%" }
                                },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 16 } },
                                    [
                                      _c("el-progress", {
                                        attrs: {
                                          "stroke-width": 16,
                                          percentage: item.rate,
                                          "text-inside": true
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { "font-size": "14px" },
                                      attrs: { span: 8 }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.name) +
                                          "(" +
                                          _vm._s(item.format) +
                                          ")"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "middle" },
              [
                _c(
                  "dv-border-box-12",
                  {
                    staticClass: "middle-top",
                    attrs: { "background-color": "#232931" }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "100%", height: "15%" } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { color: "#ff8878" },
                                attrs: { span: 4 }
                              },
                              [_vm._v("中分进度")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { height: "10px" },
                                attrs: { span: 20 }
                              },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: _vm.hg_id == 0 ? "primary" : ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.setHgId(0)
                                          }
                                        }
                                      },
                                      [_vm._v("全部分组")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.config.halve_group, function(
                                      item
                                    ) {
                                      return _c(
                                        "el-button",
                                        {
                                          key: item.hg_id,
                                          attrs: {
                                            size: "mini",
                                            type:
                                              _vm.hg_id == item.hg_id
                                                ? "primary"
                                                : ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setHgId(item.hg_id)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(item.hg_show_id))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  color: "#fff",
                                  "font-size": "12px"
                                }
                              },
                              [_vm._v("任务数")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { height: "85%", width: "100%" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "line-height": "80px",
                              width: "50%",
                              "text-align": "left",
                              float: "left"
                            }
                          },
                          [
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _vm._v(
                                    "中分任务\n                  " +
                                      _vm._s(
                                        _vm.board_data.surpass_data.staticis
                                          .all_num
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _vm._v(
                                    "点货中\n                  " +
                                      _vm._s(
                                        _vm.board_data.surpass_data.staticis
                                          .talling_num
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _vm._v(
                                    "已完成\n                  " +
                                      _vm._s(
                                        _vm.board_data.surpass_data.staticis
                                          .complete_num
                                      ) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _vm._v(
                                    "待拣货\n                  " +
                                      _vm._s(
                                        _vm.board_data.surpass_data.staticis
                                          .wait_num
                                      )
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _vm._v(
                                    "未完成\n                  " +
                                      _vm._s(
                                        _vm.board_data.surpass_data.staticis
                                          .unfinish_num
                                      ) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _vm._v(
                                    "可分播\n                  " +
                                      _vm._s(
                                        _vm.board_data.surpass_data.staticis
                                          .can_cut_num
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "50%",
                              height: "100%",
                              float: "right"
                            }
                          },
                          [_c("dv-charts", { attrs: { option: _vm.hg_ring } })],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { height: "2%" } }),
                _vm._v(" "),
                _c(
                  "dv-border-box-12",
                  {
                    staticClass: "middle-middle",
                    attrs: { "background-color": "#232931" }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "100%", height: "15%" } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { color: "#ff8878" },
                                attrs: { span: 4 }
                              },
                              [_vm._v("分播进度")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { height: "10px" },
                                attrs: { span: 20 }
                              },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type:
                                            _vm.cut_type == 1 ? "primary" : ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.setCutType(1)
                                          }
                                        }
                                      },
                                      [_vm._v("按波次单")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type:
                                            _vm.cut_type == 2 ? "primary" : ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.setCutType(2)
                                          }
                                        }
                                      },
                                      [_vm._v("按代采组")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type:
                                            _vm.cut_type == 3 ? "primary" : ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.setCutType(3)
                                          }
                                        }
                                      },
                                      [_vm._v("按商家")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type:
                                            _vm.cut_type == 4 ? "primary" : ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.setCutType(4)
                                          }
                                        }
                                      },
                                      [_vm._v("按汇总单")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  color: "#fff",
                                  "font-size": "12px"
                                }
                              },
                              [_vm._v("件数")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { width: "100%", height: "85%" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "50%",
                              height: "100%",
                              float: "left"
                            }
                          },
                          [
                            _c("dv-capsule-chart", {
                              staticStyle: {
                                height: "60%",
                                "margin-top": "20%"
                              },
                              attrs: { config: _vm.cuting }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.cut_type == 1
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "50%",
                                  height: "100%",
                                  float: "right"
                                }
                              },
                              [
                                _c("dv-charts", {
                                  attrs: { option: _vm.cut_ring }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { height: "2%" } }),
                _vm._v(" "),
                _c(
                  "dv-border-box-12",
                  {
                    staticClass: "middle-bottom",
                    attrs: { "background-color": "#232931" }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "100%", height: "15%" } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { staticStyle: { color: "#ff8878" } },
                              [_vm._v("打包进度")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  color: "#fff",
                                  "font-size": "12px"
                                }
                              },
                              [_vm._v("波次数")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { height: "85%", width: "100%" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "50%",
                              height: "100%",
                              float: "left",
                              "line-height": "60px"
                            }
                          },
                          [
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _vm._v("待打包")
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.board_data.pack_data.wait_pack_num
                                    )
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _vm._v("已打包")
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _vm._v(
                                    _vm._s(_vm.board_data.pack_data.packed_num)
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              {
                                staticStyle: {
                                  "line-height": "30px",
                                  "margin-top": "15px"
                                }
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c("el-col", [
                                      _vm._v(
                                        "单件打包(" +
                                          _vm._s(
                                            _vm.board_data.pack_data.only_format
                                          ) +
                                          ")"
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c("el-progress", {
                                          attrs: {
                                            "stroke-width": 26,
                                            percentage:
                                              _vm.board_data.pack_data
                                                .only_rate,
                                            "text-inside": true
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "50%",
                              height: "100%",
                              float: "right"
                            }
                          },
                          [
                            _c("dv-charts", {
                              attrs: { option: _vm.pack_ring }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "dv-border-box-12",
                  {
                    staticClass: "right-content",
                    attrs: { "background-color": "#232931" }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "100%", height: "6%" } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  color: "#fff",
                                  "font-size": "20px",
                                  "font-weight": "bold"
                                },
                                attrs: { span: 14 }
                              },
                              [_vm._v("拣货效率\n              ")]
                            ),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 10 } }, [
                              _vm._v(
                                "平均效率" +
                                  _vm._s(
                                    _vm.board_data.pad_efficiency.total_rate
                                  ) +
                                  "件/人"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-row", [_c("el-col", [_c("hr")])], 1)
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { width: "100%", height: "90%" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: { height: "20%" },
                            attrs: { id: "top" }
                          },
                          [
                            _c("dv-scroll-board", {
                              staticStyle: { height: "100%" },
                              attrs: { config: _vm.topFiveScroll }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: { height: "60%", "margin-top": "2%" },
                            attrs: { id: "normal" }
                          },
                          [
                            _c("dv-scroll-board", {
                              staticStyle: { height: "100%" },
                              attrs: { config: _vm.normalScroll }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: { height: "20%", "margin-top": "2%" },
                            attrs: { id: "down" }
                          },
                          [
                            _c("dv-scroll-board", {
                              staticStyle: { height: "100%" },
                              attrs: { config: _vm.downFiveScroll }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-585ad869", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-585ad869","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/monitorscreen/Board.vue
// module id = null
// module chunks = 